import { render } from "./Comparer.vue?vue&type=template&id=632abed6"
import script from "./Comparer.vue?vue&type=script&lang=js"
export * from "./Comparer.vue?vue&type=script&lang=js"
script.render = render

export default script